import React, { useState, useEffect, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Form, Col } from 'react-bootstrap';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { STRINGS_CIBIO } from '../../../../util/authorizationsCIBIO/string';
import { STRINGS } from '../../../../util/strings';
import If from '../../../../components/If';
import Loading from '../../../../components/Loading';
import Button from '../../../../components/Button';
import EditButton from '../../../../components/EditButton';
import SearchEmpty from '../../../../components/SearchEmpty';
import AlertError from '../../../../components/AlertError';
import { DestinatarioResult } from '../../../../models/modelsAuthorizationsCIBIO';
import { statusToText } from '../../../../functions/formatStatus';
import api from '../../../../services/api';
import '../../../Cultivares/styles_list.css';

export default function Destinatario ()
{
	const history = useHistory();
	const [Destinatarios, setDestinatarios] = useState<DestinatarioResult[]>([]);
	const [errorSearch, setErrorSearch] = useState<any>(null);
	const [errorGetDestinatarios, setErrorGetDestinatarios] = useState<any>(null);
	const [emptySearch, setEmptySearch] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(true);
	const [loadingSearch, setLoadingSearch] = useState<boolean>(false);

	const { register, handleSubmit, getValues } = useForm({
		defaultValues: { name: '', active: true },
	})

	useEffect(() => {
		const getDestinatarios = async () => {
			try {
				const { data, status } = await api.get<DestinatarioResult[]>('api/v1/autorizacoes-cibio/Destinatario/obterporfiltro?Ativo=true');

				if (status === 200) {
					setDestinatarios(data);
				}
			} catch (error:any) {
				setErrorGetDestinatarios(error?.response?.data);
			}
			setLoading(false);
		}

		getDestinatarios();
	}, []);

	const search = async () => {
		let nome = getValues('name');
		let email = getValues('email');
		let ativo = getValues('active');
		setLoadingSearch(true);
		setErrorSearch(null);

		try {
			const { data } = await api.get<DestinatarioResult[]>(`api/v1/autorizacoes-cibio/Destinatario/obterporfiltro?Nome=${nome}&Ativo=${ativo}`);

			if (data.length) {
				setDestinatarios(data);
				setEmptySearch(false);
			} else {
				setEmptySearch(true);
			}

		} catch (error:any) {
			setErrorSearch(error?.response?.data);
		}
		setLoadingSearch(false);
	}

	const actions = ({ data }: any) => (
		<Fragment>
			<EditButton
				onClick={() => history.push({
					pathname: '/autorizacoes/editar/destinatario',
					state: {
						id: data.id
					}
				})}
			/>
		</Fragment>
	)

	return <div className="container-custom-search">
		<If condition={errorGetDestinatarios !== null && !Destinatarios.length}>
			{errorGetDestinatarios !== null && errorGetDestinatarios.message.length > 0 ? errorGetDestinatarios.message.map((error: string) => <AlertError message={error} />) : <AlertError message={STRINGS.ALERT_GENERIC_ERROR} />}
		</If>
		<If condition={errorSearch !== null && !Destinatarios.length}>
			{errorSearch !== null && errorSearch.message.length > 0 ? errorSearch.message.map((error: string) => <AlertError message={error} />) : <AlertError message={STRINGS.ALERT_GENERIC_ERROR} />}
		</If>
		<div className="top-content">
			<h3>{STRINGS_CIBIO.SEARCH_RECEIVER}</h3>
		</div>
		<div className="row-buttons">
			<Button
				onClick={() => history.push('/autorizacoes/cadastrar/destinatario')}
				contained
				title="Adicionar"
				type="button"
			/>
		</div>
		<br />
		<Form onSubmit={handleSubmit(search)}>
			<Form.Row className="row-custom">
				<Form.Group as={Col} md={4}>
					<Form.Label>Nome do Destinatário</Form.Label>
					<Form.Control
						ref={register}
						name="name"
						maxLength={15}
						autoComplete="off"
					/>
				</Form.Group>
				<Form.Group as={Col} md={4}>
					<Form.Label>Email do Destinatário</Form.Label>
					<Form.Control
						ref={register}
						name="email"
						maxLength={15}
						autoComplete="off"
					/>
				</Form.Group>
				<Form.Group>
					<Form.Label />
					<Form.Check
						type="checkbox"
						ref={register}
						name="active"
						label="Ativos"
					/>
				</Form.Group>
				<span className="filter-btn">
					<Button
						title="Buscar"
						type="submit"
						contained
						isLoading={loadingSearch}
					/>
				</span>
			</Form.Row>
		</Form>
		<If condition={!loading && !emptySearch && Destinatarios.length}>
			<div className="search-content">
				<div className="ag-theme-alpine" style={{ height: '70vh', width: '100%' }}>
					<AgGridReact
						rowData={Destinatarios}
						defaultColDef={{ flex: 1, sortable: true, resizable: true }}
						pagination
						paginationPageSize={10}
						frameworkComponents={{
							actions: actions,
						}}
					>
						<AgGridColumn
							headerName='Nome do Destinatario'
							field="nome"
							cellStyle={{
								justifyContent: 'left'
							}}
							sort="asc"
						/>
						<AgGridColumn
							headerName='Email do Destinatario'
							field="email"
							cellStyle={{
								justifyContent: 'left'
							}}
							sort="asc"
						/>
						<AgGridColumn
							headerName="Status"
							field="ativo"
							valueFormatter={({ data }: any) => statusToText(data.ativo)}
							maxWidth={130}
						/>
						<AgGridColumn
							field='Ações'
							cellRenderer='actions'
							maxWidth={130}
						/>
					</AgGridReact>
				</div>
			</div>
		</If>
		<If condition={loading}>
			<div className="loading-container">
				<Loading />
			</div>
		</If>
		<If condition={emptySearch}>
			<div className="div-empty">
				<SearchEmpty />
			</div>
		</If>
	</div>;
}